import { createActionGroup, props } from '@ngrx/store';
import { LocationAcl, LocationAclGroups, LocationAclMembers } from '@rocksoft/locations-sdk';
import { Group } from '@rocksoft/security-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const LocationPermissionsResolverActions = createActionGroup({
  source: 'Location Permissions Resolver',
  events: {
    'Location acl requested': props<{ resourceId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AccessControlListApiActions = createActionGroup({
  source: 'Access Control List Controller',
  events: {
    'Location acl loaded': props<{ locationAcl: LocationAcl }>(),
    'Location acl loaded error': props<{ error: ErrorModel }>(),
    'Location acl member put': props<{ aclMember: LocationAclMembers }>(),
    'Location acl group put': props<{ aclGroup: LocationAclGroups }>(),
    'Location acl group remove': props<{ aclGroup: LocationAclGroups }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const LocationAclPermissionsUiActions = createActionGroup({
  source: 'Location Settings Acl Permissions Component',
  events: {
    'Location acl member put': props<{ aclMember: LocationAclMembers }>(),
    'Location acl group put': props<{ aclGroup: LocationAclGroups }>(),
    'Location acl group remove': props<{ aclGroup: LocationAclGroups }>(),
  },
});

export const LocationPermissionsComponentActions = createActionGroup({
  source: 'Location Permissions Component',
  events: {
    'Add group': props<{ group: Group }>(),
  },
});
